export function CollectionTabs() {
  // Back navigation is supplied once, consistently, by the app layout.
  return null;
}
